<template>
    <div class="roomContent">
        <div class="mask" v-if="editFloorContentPopupShow">
            <div class="floor-content-popup">
                <div class="floor-content-close" @click.stop="getFloor"></div>
                <!-- 楼层 -->
                <div class="floor-content-head">
                    <ul>
                        <!-- <li 
                                :class="[
                                    arrEditFloorContent.activeIndex === index ? 'tab-active':'', 
                                    arrEditFloorContent.floor.length <= 3 ? 'li-flex':'li-noflex']" 
                                v-for="(item, index) in arrEditFloorContent.floor" 
                                :key="index"
                                @click.stop="arrEditFloorContent.activeIndex = index"
                            >{{ item.name }}</li> -->
                    </ul>
                </div>

                <!-- 选择的空间 -->
                <div class="scroll-wrap">
                    <div class="select-tags-content">
                        <div class="select-tags-title">已选空间</div>
                        <div class="select-tags-scroll">
                            <div
                                class="select-tags-list"
                                v-if="arrEditFloorContent.floor.length !== 0"
                            >
                                <div
                                    :class="[
                                        'select-tags',
                                        item.common_use === 0 ? 'selected' : '',
                                    ]"
                                    v-for="(
                                        item, index
                                    ) in arrEditFloorContent.floor"
                                    :key="index"
                                >
                                    <span class="room-name"
                                        >{{ item.name
                                        }}{{
                                            item.isNumber === 1
                                                ? item.number
                                                : ""
                                        }}</span
                                    >
                                    <input
                                        type="number"
                                        pattern="[0-9]*"
                                        name=""
                                        v-model="item.area"
                                    />
                                    <span class="unit">m²</span>
                                    <div
                                        class="close-icon"
                                        @click.stop="deleteTags()"
                                    ></div>
                                </div>
                            </div>
                            <p class="no-data" v-else>请点击选择空间</p>
                        </div>
                    </div>
                    <div class="add-tags-content">
                        <div
                            class="cell"
                            v-for="(
                                item, index
                            ) in arrEditFloorContent.allTagContent"
                            :key="index"
                        >
                            <div class="cell-head">{{ item.name }}</div>
                            <div class="cell-center">
                                <div
                                    class="cell-item"
                                    v-for="(
                                        childItem, childIndex
                                    ) in item.allTags"
                                    :key="childIndex"
                                    @click="
                                        addTagschange(childItem, childIndex)
                                    "
                                >
                                    {{ childItem.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="floor-content-btn">
                    <button @click.stop="floorContentPopupConfirm()">
                        确定
                    </button>
                </div>
            </div>
        </div>
        <!-- 填写面积弹窗 -->
        <div class="mask" v-if="areaPopupShow">
            <div class="input-area-popup">
                <div
                    class="input-area-close"
                    @click.stop="areaPopupShow = false"
                ></div>
                <div class="input-area-title">{{ oTags.name }}:</div>
                <div class="input-area-content">
                    <div class="input-wrap">
                        <input
                            type="number"
                            pattern="[0-9]*"
                            name=""
                            v-model="areaPopupInputVal"
                        />
                        <span>m²</span>
                    </div>
                </div>
                <div class="input-area-btn">
                    <button @click.stop="areaPopupConfirm()">确定</button>
                </div>
            </div>
        </div>
        <!-- 确认删除弹窗 -->
        <div class="mask" @touchmove.prevent v-if="bConfirmPopupShow">
            <div class="confirm-popup">
                <div
                    class="popup-close"
                    @click.stop="bConfirmPopupShow = false"
                ></div>
                <div class="confirm-content">
                    <p>确认要删除当前空间?</p>
                </div>
                <div class="confirm-btn">
                    <button @click.stop="bConfirmPopupShow = false">
                        取消
                    </button>
                    <button @click.stop="popupConfirm()">确定</button>
                </div>
            </div>
        </div>
        <!-- 非频繁使用区域 -->
        <div class="mask" v-if="bNoOftenPopupShow">
            <div class="public-popup">
                <div
                    class="popup-close"
                    @click.stop="bNoOftenPopupShow = false"
                ></div>
                <div class="popup-title">非频繁使用区域</div>
                <div class="public-content scorll">
                    <div class="group">
                        <div class="tag">
                            <div
                                :class="[
                                    'tag-item',
                                    tagItem.check ? 'active' : '',
                                ]"
                                v-for="(
                                    tagItem, tagIndex
                                ) in arrEditFloorContent.floor"
                                :key="tagIndex"
                                @click="noOftenPopupSlect(tagItem, tagIndex)"
                            >
                                {{ tagItem.name
                                }}{{
                                    tagItem.isNumber === 1 ? tagItem.number : ""
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn">
                    <button @click="noOftenPopupConfirm()">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        editFloorContentPopupShow: {
            type: Boolean,
            default: false,
        },
        arrEditFloorContent: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            areaPopupInputVal: "",
            oTags: {}, // 需要修改面积的tags
            areaPopupShow: false,
            bConfirmPopupShow: false,
            deleteIndex: 0,
            bNoOftenPopupShow: false,
            arrNoOftenTagList: [],
        };
    },
    methods: {
        getFloor() {
            this.$emit("update:editFloorContentPopupShow", false);
        },
        // 选择增加的标签
        addTagschange(item, index) {
            this.areaPopupInputVal = "";
            item.check = false;
            this.oTags = JSON.parse(JSON.stringify(item));
            this.areaPopupShow = true;
        },
        noOftenPopupSlect(tagItem, tagIndex) {
            this.arrEditFloorContent.floor[tagIndex].check =
                !this.arrEditFloorContent.floor[tagIndex].check;
        },
        noOftenPopupConfirm() {
            let arrTips = [],
                areaTips = [];
            this.arrEditFloorContent.floor.forEach((it) => {
                it.energy_cold = Number(
                    it.energy_cold_per * it.area * it.direction_s
                ).toFixed(2);
                it.energy_hot = Number(
                    it.energy_hot_per * it.area * it.direction_s
                ).toFixed(2);
                if (it.length === 0) {
                    arrTips.push(it.name);
                } else {
                    if (!it.area) {
                        areaTips.push(`${it.name}的面积还未填写！`);
                    }
                }
                if (it.check) {
                    it.common_use = 0;
                } else {
                    it.common_use = 1;
                }
            });
            if (arrTips.length !== 0) {
                this.$toast(`${arrTips[0]}还未增加内容！`);
                return false;
            }
            if (areaTips.length !== 0) {
                this.$toast(`${areaTips[0]}`);
                return false;
            }
            this.bNoOftenPopupShow = false;
            this.$emit("floorContentPopupConfirm", this.arrEditFloorContent);
        },
        // 输入面积弹窗确定
        areaPopupConfirm() {
            if (!this.areaPopupInputVal) {
                this.$toast("请输入面积！");
                return false;
            }
            this.oTags.area = this.areaPopupInputVal;
            this.arrEditFloorContent.floor.push(this.oTags);
            const tagsData = JSON.parse(
                JSON.stringify(this.arrEditFloorContent.floor)
            );
            this.arrEditFloorContent.floor = tagsData;
            this.areaPopupShow = false;
        },
        // 删除选择的标签
        deleteTags(index) {
            this.deleteIndex = index;
            this.bConfirmPopupShow = true;
        },
        // 确认弹窗 确认删除
        popupConfirm() {
            this.arrEditFloorContent.floor.splice(this.deleteIndex, 1);
            this.bConfirmPopupShow = false;
        },
        // 编辑楼层内容弹窗确认
        floorContentPopupConfirm() {
            this.bNoOftenPopupShow = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 888;
    display: flex;
    justify-content: center;
    align-items: center;
}
.tag {
    width: 100%;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .tag-item {
        background-color: rgb(247, 247, 253);
        border-radius: 55px;
        font-size: 30px;
        color: rgb(45, 45, 45);
        text-align: center;
        height: 70px;
        line-height: 72px;
        margin-right: 15px;
    }
    .tag-item:last-child {
        margin-right: 0;
    }
    .active {
        border-width: 2px;
        border-color: rgb(44, 122, 236);
        border-style: solid;
        color: rgb(44, 122, 236);
    }
}
.public-popup {
    width: 652px;
    min-height: 500px;
    border-radius: 20px;
    background-color: rgb(255, 255, 255);
    padding: 40px 20px;
    z-index: 995;
    position: relative;
    .popup-tips {
        font-size: 28px;
        color: #999999;
    }
    .popup-title {
        font-size: 34px;
        color: rgb(45, 45, 45);
    }
    .group {
        flex-wrap: wrap;
        .tag {
            margin-top: 15px;
            flex-wrap: wrap;
            .tag-item {
                min-width: 180px;
                padding: 0 30px;
                flex-shrink: 0;
                margin: 0 8px 20px 8px;
            }
            .other {
                min-width: 130px;
                padding: 0 20px;
            }
            .active {
                border-width: 2px;
                border-color: rgb(44, 122, 236);
                border-style: solid;
                color: rgb(44, 122, 236);
            }
        }
    }
    .btn {
        margin-top: 50px;
        display: flex;
        justify-content: center;
        button {
            width: 290px;
            height: 80px;
            background-color: #2c7aec;
            border-radius: 55px;
            outline: none;
            color: #fff;
            font-size: 30px;
        }
    }
    .scorll {
        height: 400px;
        overflow-x: scroll;
    }
}
.floor-content-popup {
    width: 690px;
    min-height: 500px;
    border-radius: 20px;
    background-color: rgb(255, 255, 255);
    padding: 20px;
    z-index: 990;
    position: relative;
    .floor-content-close {
        position: absolute;
        top: -14px;
        right: -14px;
        background: url("~@/assets/images/antV2/basicinfo/close.png") top/100%
            auto no-repeat;
        width: 42px;
        height: 42px;
        flex-shrink: 0;
    }
    .floor-content-head {
        width: 100%;
        overflow-x: scroll;
        &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
            color: transparent !important;
            display: none;
        }
        ul {
            padding: 0 10px;
            display: flex;
            li {
                height: 70px;
                line-height: 70px;
                font-size: 34px;
                color: rgb(51, 51, 51);
                text-align: center;
                font-weight: bold;
                position: relative;
                &::before {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    display: inline-block;
                    content: "";
                    background-color: rgb(204, 204, 204);
                    width: 100%;
                    height: 8px;
                }
            }
            li:first-child {
                &::before {
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                }
            }
            li:last-child {
                &::before {
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                }
            }
            .li-flex {
                width: 100%;
            }
            .li-noflex {
                flex-shrink: 0;
                width: 250px;
            }
            .tab-active {
                color: rgb(44, 122, 236);
                &::before {
                    background-color: rgb(44, 122, 236);
                    border-radius: 10px;
                }
            }
        }
    }
    .scroll-wrap {
        // height: 900px;
        height: calc(100vh - 300px);
        overflow-y: scroll;
        &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
            color: rgb(44, 122, 236) !important;
            display: none;
        }
    }
    .select-tags-content {
        margin-top: 30px;
        border-width: 1px;
        border-color: #cccccc;
        border-style: solid;
        border-radius: 20px;
        padding: 20px 20px;
        .select-tags-title {
            font-size: 30px;
            color: rgb(51, 51, 51);
            font-weight: bold;
        }
        .select-tags-scroll {
            margin-top: 15px;
            // height: 250px;
            // overflow-y: scroll;
            .select-tags-list {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .select-tags {
                    display: flex;
                    align-items: center;
                    background-color: rgb(247, 247, 253);
                    padding: 15px 20px;
                    border-radius: 30px;
                    margin-bottom: 15px;
                    position: relative;
                    .room-name {
                        width: 115px;
                        font-size: 28px;
                        color: rgb(45, 45, 45);
                    }
                    input {
                        margin-right: 20px;
                        width: 70px;
                        // height: 30px;
                        border-bottom: 1px solid rgb(229, 229, 229);
                        background: transparent;
                        text-align: center;
                        font-size: 30px;
                        // padding: 5px 0;
                    }
                    .unit {
                        font-size: 28px;
                        color: rgb(107, 107, 107);
                    }
                    .close-icon {
                        flex-shrink: 0;
                        width: 22px;
                        height: 22px;
                        background: url("~@/assets/images/antV2/icon_close2.png")
                            top/100% auto no-repeat;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
                .selected {
                    background-color: rgb(229, 229, 229);
                    input {
                        border-bottom: 1px solid rgb(107, 107, 107);
                    }
                }
            }
            .no-data {
                margin: 50px 0;
                font-size: 32px;
                color: rgb(107, 107, 107);
                text-align: center;
            }
        }
        .add-space {
        }
        .select-tags-tips {
            margin-top: 15px;
            font-size: 24px;
            color: rgb(153, 153, 153);
        }
    }
    .add-tags-content {
        margin-top: 15px;
        // height: calc(100vh - 750px);
        // overflow-y: scroll;
        .cell {
            border-bottom: 1px solid #f2f2f2;
            display: flex;
            padding-top: 25px;
            padding-left: 20px;
            .cell-head {
                padding-top: 13px;
                font-size: 30px;
                color: rgb(51, 51, 51);
                font-weight: bold;
                flex-shrink: 0;
                width: 62px;
            }
            .cell-center {
                flex-grow: 1;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .cell-item {
                    margin: 0 6px 25px 6px;
                    background-color: rgb(247, 247, 253);
                    width: 170px;
                    height: 70px;
                    border-radius: 55px;
                    text-align: center;
                    line-height: 72px;
                    font-size: 28px;
                }
                .disable {
                    background-color: rgba(204, 204, 204, 0.5);
                    color: rgb(107, 107, 107);
                }
            }
        }
    }
    .floor-content-btn {
        margin-top: 30px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        button {
            width: 290px;
            height: 80px;
            background-color: #2c7aec;
            border-radius: 55px;
            outline: none;
            color: #fff;
            font-size: 30px;
        }
    }
}
.popup-close {
    position: absolute;
    top: -15px;
    right: -15px;
    background: url("~@/assets/images/antV2/basicinfo/close.png") top/100% auto
        no-repeat;
    width: 42px;
    height: 42px;
    flex-shrink: 0;
}
.input-area-popup {
    width: 690px;
    border-radius: 20px;
    background-color: rgb(255, 255, 255);
    padding: 40px;
    z-index: 990;
    position: relative;
    .input-area-close {
        position: absolute;
        top: -14px;
        right: -14px;
        background: url("~@/assets/images/antV2/basicinfo/close.png") top/100%
            auto no-repeat;
        width: 42px;
        height: 42px;
        flex-shrink: 0;
    }
    .input-area-title {
        font-size: 30px;
        color: rgb(51, 51, 51);
        font-weight: bold;
    }
    .input-area-content {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        .input-wrap {
            border-width: 2px;
            border-color: rgb(204, 204, 204);
            border-style: solid;
            border-radius: 30px;
            width: 278px;
            height: 65px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 30px;
            input {
                width: 100%;
                font-size: 30px;
                text-align: center;
            }
            span {
                flex-shrink: 0;
                font-size: 28px;
                color: rgb(107, 107, 107);
            }
        }
    }
    .input-area-btn {
        margin-top: 30px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        button {
            width: 290px;
            height: 80px;
            background-color: #2c7aec;
            border-radius: 55px;
            outline: none;
            color: #fff;
            font-size: 30px;
        }
    }
}
.confirm-popup {
    width: 652px;
    min-height: 440px;
    border-radius: 20px;
    background-color: rgb(255, 255, 255);
    padding: 40px;
    z-index: 999;
    position: relative;
    .confirm-content {
        p {
            margin: 100px;
            text-align: center;
            font-size: 34px;
            color: rgb(51, 51, 51);
            font-weight: bold;
        }
    }
    .confirm-btn {
        display: flex;
        justify-content: center;
        button:nth-child(1) {
            width: 180px;
            height: 80px;
            border-radius: 55px;
            border-width: 2px;
            border-color: rgb(51, 51, 51);
            border-style: solid;
            color: rgb(51, 51, 51);
            background-color: #fff;
            margin-right: 30px;
            font-size: 30px;
        }
        button:nth-child(2) {
            width: 180px;
            height: 80px;
            background-color: #2c7aec;
            border-radius: 55px;
            outline: none;
            color: #fff;
            font-size: 30px;
        }
    }
}
</style>